import React, { useState } from 'react'
import { Field } from 'formik'
import PropTypes from 'prop-types'

import { IfAuthenticated, UnlessAuthenticated } from '../IfAuthenticated/IfAuthenticated'
import Checkbox from '../Form/Checkbox/Checkbox'
import Error from '../Error/Error'
import Progress from '../Progress/Progress'

import { useCreditCard } from '../CreditCardProvider/CreditCardProvider'

import { TermsModal, SAVE_CARD } from '../TermsModal/TermsModal'

import InfoImg from '../../assets/info.svg'
import './SaveNewCardCheckbox.css'

export const SaveNewCardCheckbox = ({ disabled, field, onChange = field.onChange }) => {
  const [shouldShowTerms, editShowTerms] = useState(false)
  const { creditCards = [], loading, error } = useCreditCard()

  // eslint-disable-next-line react/prop-types
  const Label = ({ text }) => (
    <span>
      <span>
        {text}
        <button
          data-testid='save-new-card-terms-button'
          styleName='infoButton'
          onClick={() => editShowTerms(!shouldShowTerms)}
          type='button'
        >
          <InfoImg styleName='infoImage' />
        </button>
      </span>
    </span>
  )

  return (
    <React.Fragment>
      {shouldShowTerms && (
        <TermsModal onClose={() => editShowTerms(false)} terms={SAVE_CARD} />
      )}
      <IfAuthenticated>
        {() => {
          if (loading) {
            return <Progress eventData={{ category: 'Save New Card Checkbox' }} />
          }

          if (error) {
            return <Error error={error} />
          }

          if (creditCards && creditCards.length >= 3) {
            return <p>* You have already saved 3 credit cards. You can still use this card to complete your order.</p>
          }

          return (
            <Field
              component={Checkbox}
              name={field.name}
              value={field.value}
              id={`${field.name}_authenticated_checkbox`}
              disabled={disabled}
              onChange={onChange}
              label={<Label text='Remember this card' />}
            />
          )
        }}
      </IfAuthenticated>
      <UnlessAuthenticated>
        <Field
          component={Checkbox}
          name={field.name}
          value={field.value}
          id={`${field.name}_unauthenticated_checkbox`}
          disabled={disabled}
          onChange={onChange}
          label={<Label text='Remember this card and create account' />}
        />
      </UnlessAuthenticated>
    </React.Fragment>
  )
}

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired
})

SaveNewCardCheckbox.propTypes = {
  disabled: PropTypes.bool,
  field: FieldShape.isRequired,
  onChange: PropTypes.func
}
